import { SparePartStateUponReceipt } from '@savgroup-front-common/types';

import sparePartStateUponReceiptMessages from '../helpers/i18n/messages/sparePartStateUponReceiptMessages';

import { safeFormattedIntlString } from './safeFormattedIntlString';

const getSparePartRequestStateUponReceipt = (
  status: SparePartStateUponReceipt,
): ReturnType<typeof safeFormattedIntlString> => {
  let message;

  switch (status) {
    case SparePartStateUponReceipt.BROKEN: {
      message = sparePartStateUponReceiptMessages.broken;
      break;
    }
    case SparePartStateUponReceipt.COMPLIANT: {
      message = sparePartStateUponReceiptMessages.compliant;
      break;
    }
    case SparePartStateUponReceipt.MISMATCH: {
      message = sparePartStateUponReceiptMessages.mismatch;
      break;
    }
    case SparePartStateUponReceipt.MISMATCH_WRONG_PART: {
      message = sparePartStateUponReceiptMessages.mismatchWrongPart;
      break;
    }

    default:
      throw new Error('Request line state does not exist');
      break;
  }

  return safeFormattedIntlString(message);
};

export default getSparePartRequestStateUponReceipt;
